 <template>
  <el-card v-loading="loading">
    <section class="flex justify-bet wrap">
      <div class="flex wrap">
        <el-input
          style="width: 250px"
          class="mt-3 mr-5"
          v-model="input"
          placeholder="Order Number"
          @keyup.enter.native="filterTable"
          @blur="filterTable"
          clearable
          @clear="filterTable"
          prefix-icon="el-icon-search"
        ></el-input>
        <el-date-picker
          v-model="date"
          class="mt-3"
          clearable
          type="datetimerange"
          start-placeholder="Start"
          end-placeholder="End"
          @change="filterTable"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 400px"
        ></el-date-picker>
      </div>
      <div class="mt-3">
        <vs-button @click="withdrawListBlob" size="small" type="border"
          >Export</vs-button
        >
      </div>
    </section>
    <el-table
      ref="multipleTable"
      :header-cell-style="{ 'text-align': 'center' }"
      :cell-style="{ 'text-align': 'center' }"
      stripe
      :data="tableData"
      style="width: 100%"
    >
      <!-- @select="selectOneRow"
      @select-all="selectAll" -->
      <!-- <el-table-column
        :selectable="columFunc"
        type="selection"
        width="55"
      ></el-table-column> -->
      <el-table-column
        width="80"
        sortable
        prop="id"
        label="Id"
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        sortable
        prop="order_id"
        label="Order No."
      ></el-table-column>
      <el-table-column
        show-overflow-tooltip
        sortable
        prop="chain"
        label="Chain"
      >
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        sortable
        prop="symbol"
        label="Symbol"
      >
      </el-table-column>
      <el-table-column
        show-overflow-tooltip
        sortable
        prop="address"
        label="Address"
      >
        <template slot-scope="scope">
          <span class="text-elli">{{ scope.row.address }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="amount" label="Amount"></el-table-column>
      <el-table-column show-overflow-tooltip sortable prop="txid" label="TxID">
        <template slot-scope="scope">
          <span class="text-elli">{{
            scope.row.txid ? scope.row.txid : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column sortable prop="status" label="Status">
        <template slot-scope="scope">
          <span
            >{{ scope.row.status | computedStatus }}</span
          >
        </template>
      </el-table-column>
      <el-table-column sortable prop="updated_at" label="Update Time"></el-table-column>
      <!-- <el-table-column label="Action" width="150">
        <template slot-scope="scope">
          <vs-button
            @click="showDialog(scope.row)"
            size="small"
            color="primary"
            type="border"
            >Details</vs-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination
      class="flex flex-end mt-5"
      @current-change="handleCurrentChange"
      :current-page="page"
      :pager-count="5"
      layout="total, prev, pager, next"
      :total="total"
    ></el-pagination>

    <!-- <vs-popup title="Detail" :active.sync="dialogVisible">
      <el-row class="detail-view">
        <el-col :span="24">
          <ul>
            <li>
              <span>Name:</span>
              <span>{{ dialogData.merchant_name }}</span>
            </li>
            <li>
              <span>Address:</span>
              <span style="color: #67c23a">{{ dialogData.address }}</span>
            </li>
            <li>
              <span>Tx:</span>
              <span style="color: #67c23a">{{
                dialogData.txid ? dialogData.txid : "-"
              }}</span>
            </li>
            <li>
              <span>Amount:</span>
              <span>{{ dialogData.amount }}</span>
            </li>
            <li>
              <span>Price:</span>
              <span>{{ dialogData.price }}</span>
            </li>

            <li>
              <span>Time:</span>
              <span>{{ dialogData.timestamp }}</span>
            </li>
            <li>
              <span>Status:</span>
              <span
                :style="{
                  color:
                    dialogData.withdraw_status == 0
                      ? '#7367f0'
                      : dialogData.withdraw_status == 1
                      ? '#ff9f43'
                      : dialogData.withdraw_status == 2
                      ? '#28c76f'
                      : '',
                }"
                >{{ dialogData.withdraw_status | computedStatus }}</span
              >
            </li>
          </ul>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="dialogVisible = false"
          >Confirm</el-button
        >
      </span>
    </vs-popup> -->

  </el-card>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      input: "",
      date: "",
      start: 0,
      end: 0,
      tableData: [],
      dialogVisible: false,
      dialogData: {},
      size: 10,
      page: 1,
      total: 0,

      selectArr: [],
      txid: "",
      password: ""
    }
  },
  created () {
    this.getTable();
  },

  watch: {},

  filters: {
    computedStatus (val) {
      return val == 0 ? "Pendding" : val == 1 ? 'Processing' : val == 2 ? 'Confirming': val == 3 ? 'Done' :val == 4 ? 'Failed' :val == 5 ? 'Cancelled' : "Unknown"
    }
  },
  methods: {
    // columFunc (row, rowIndex) {
    //   if (row.withdraw_status == 2) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },

    filterTable () {
      console.log(this.date);
      this.page = 1;
      this.getTable();
    },
    getTable () {
      this.$api.mwt_list({
        keywords: this.input,
        start_time: this.date[0],
        end_time: this.date[1],
        size: this.size,
        page: this.page
      }).then(res => {
        this.tableData = res.data.data.data;
        this.total = res.data.data.total;
        this.loading = false;
      })
    },

    // selectOneRow (selection, row) {
    //   if (this.selectArr.indexOf(row.id) < 0) {
    //     this.selectArr.push(row.id);
    //   }
    // },

    // selectAll (selection) {
    //   selection.forEach(row => {
    //     if (row.withdraw_status != 2) {
    //       if (this.selectArr.indexOf(row.id) < 0) {
    //         this.selectArr.push(row.id);
    //       }
    //     }
    //   });
    // },


    withdrawListBlob () {
      this.$api.withdrawListBlob({
        keywords: this.input,
        start_time: this.date[0],
        end_time: this.date[1] ,
        download_type: 'mwt_List'
      }).then(res => {
        this.downLoadFile(res.data, 'withdraw_order')
      })
    },

    // showDialog (row) {
    //   this.dialogData = row;
    //   this.dialogVisible = true;
    // },
    handleSizeChange (val) {
      this.size = val;
      this.getTable();
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getTable();
    }
  }
}
</script>
<style lang="scss">
</style>